module.exports = __webpack_public_path__ + "static/media/IQ.c3104587.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/IQ.svg
// module id = 2175
// module chunks = 7